var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"my-5"},[_c('DataTable',{attrs:{"title":"Projects","type":"projects","headers":_vm.$tableHeaders.projects,"items":_vm.projects,"itemKey":_vm.projectEntry.id,"link":"/record/project"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }